import React from 'react';
import './App.css';
import Form from './components/Form';
import { Toaster } from 'react-hot-toast';

const App = () => {
  return (
    <>
      <Form />
      <Toaster
        position="bottom-left"
        toastOptions={{
          duration: 3000,
          style: {
              borderRadius: "8px",
              background: "#333",
              color: "#fff",
          },
        }}
      />
    </>);
}

export default App;